require("../src/bootstrap");

import "../src/connectplus.js";
import "../stylesheets/connectplus.scss";
